import {
	createContext,
	type ReactNode,
	useCallback,
	useContext,
	useState,
} from "react";

interface SearchContextType {
	onNodeSelected?: (nodeId: string) => void;
	setOnNodeSelected: (callback: (nodeId: string) => void) => void;
}

const SearchContext = createContext<SearchContextType>({
	setOnNodeSelected: () => {},
});

interface SearchProviderProps {
	children: ReactNode;
}

export function SearchProvider({ children }: SearchProviderProps) {
	const [onNodeSelected, setOnNodeSelectedState] = useState<
		((nodeId: string) => void) | undefined
	>(undefined);

	const setOnNodeSelected = useCallback(
		(callback: (nodeId: string) => void) => {
			setOnNodeSelectedState(() => callback);
		},
		[],
	);

	return (
		<SearchContext.Provider value={{ onNodeSelected, setOnNodeSelected }}>
			{children}
		</SearchContext.Provider>
	);
}

export function useSearch() {
	return useContext(SearchContext);
}
